// React
import { Fragment } from "react"

// Components
import { ActionButton } from "components"
import { DeletePurchaseOrderModal } from "pages/Purchase/components"

// Types
import type { DetailDeleteType } from "pages/Purchase/types"

// Utils
import { useToggle } from "utils"
import { PERMISION } from "security"

export function DeleteItem(params: {
  item: DetailDeleteType
  onSuccess: () => void
}) {
  // Hooks
  const { isActive, toggle } = useToggle(false)

  return (
    <Fragment>
      <ActionButton.Delete
        permission={
          PERMISION.PURCHASES.REGISTER.BY_DATE_RANGE.DELETE || 
          PERMISION.PURCHASES.REGISTER.BY_CARD.DELETE || 
          PERMISION.PURCHASES.REGISTER.BY_LOCATION.DELETE ||
          PERMISION.PURCHASES.REGISTER.BY_REFERENCE_ID.DELETE ||
          PERMISION.PURCHASES.REGISTER.BILLS_ITEM.DELETE
        }
        className="text-error"
        onClick={toggle}
      />

      {isActive && (
        <DeletePurchaseOrderModal
          onSuccess={params.onSuccess}
          toggle={toggle}
          item={{
            purchase_order_id: params.item.purchase_order_id.toString(),
            transaction_date: params.item.transaction_date,
            trx_code: params.item.trx_code,
            vendor_name: params.item.vendor_name
          }}
        />
      )}
    </Fragment>
  )
}